import React, { useState } from "react";

export default function Navbar({ setNavlink }) {
  const [linkActive, setLinkActive] = useState("about");

  const tabs = [
    { id: "about", label: "About" },
    { id: "resume", label: "Resume" },
    { id: "projects", label: "Projects" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 p-4 lg:absolute lg:bottom-auto lg:top-0 lg:right-0 lg:left-auto lg:p-6">
      <ul className="flex items-center justify-center gap-1 p-1 bg-zinc-900/90 backdrop-blur-xl border border-zinc-800/80 rounded-2xl shadow-2xl max-w-sm mx-auto lg:mx-0">
        {tabs.map((tab) => {
          const isActive = linkActive === tab.id;
          return (
            <li key={tab.id}>
              <button
                onClick={() => {
                  setNavlink(tab.id);
                  setLinkActive(tab.id);
                }}
                className={`px-4 py-2.5 rounded-xl text-xs font-semibold tracking-wide transition-all duration-300 ${
                  isActive
                    ? "bg-gradient-to-r from-violet-600 to-indigo-600 text-white shadow-md shadow-indigo-500/20 scale-102"
                    : "text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/50"
                }`}
              >
                {tab.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
